import { FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

type CustomMetricView = MetricView & { agentId: string };

export class AgentIdFilter extends MetricFilter<string> {
  public field = 'agent_id';
  public operator = FilterOperator.IN;

  constructor(agentId?: string[]) {
    super(agentId);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<AgentIdFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: AgentIdFilter): this {
    if (!(newFilter instanceof AgentIdFilter)) return this;
    if (newFilter.values === undefined) return new AgentIdFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new AgentIdFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return (metrics as unknown as CustomMetricView[]).filter((metric) =>
      this.values.some((value) => value === metric.agentId),
    ) as unknown as K[];
  }
}
